import * as actionTypes from "../ActionTypes";

export const addCurriculum = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_CURRICULUM,
    payload: payload,
  };
};

export const setCurriculum = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_CURRICULUM,
    payload: payload,
  };
};

export const setMobileView = (payload) => {
  return {
    type: actionTypes.SET_MOBILE_VIEW,
    payload: payload,
  };
};

export const addVideos = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_VIDEOS,
    payload: payload,
  };
};

export const setVideos = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_VIDEOS,
    payload: payload,
  };
};

export const addTestimonial = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_TESTIMONIALS,
    payload: payload,
  };
};

export const addJournals = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_JOURNALS,
    payload: payload,
  };
};

export const setTestimonial = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_TESTIMONIALS,
    payload: payload,
  };
};

export const addCategory = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_CATEGORY,
    payload: payload,
  };
};

export const setCategory = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_CATEGORY,
    payload: payload,
  };
};

// Bible search
export const setGlobalBibleSearchResults = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_BIBLE_SEARCH_RESULTS,
    payload,
  };
};

export const addGlobalBibleSearchResults = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_BIBLE_SEARCH_RESULTS,
    payload,
  };
};

// Video search
export const setGlobalVideoSearchResults = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_VIDEO_SEARCH_RESULTS,
    payload,
  };
};

export const addGlobalVideoSearchResults = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_VIDEO_SEARCH_RESULTS,
    payload,
  };
};

// Testimony search
export const setGlobalTestimonySearchResults = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_TESTIMONY_SEARCH_RESULTS,
    payload,
  };
};

export const addGlobalTestimonySearchResults = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_TESTIMONY_SEARCH_RESULTS,
    payload,
  };
};

// Promise search
export const setGlobalPromiseSearchResults = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_PROMISE_SEARCH_RESULTS,
    payload,
  };
};

export const addGlobalPromiseSearchResults = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_PROMISE_SEARCH_RESULTS,
    payload,
  };
};

// Journal search
export const setGlobalJournalSearchResults = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_JOURNAL_SEARCH_RESULTS,
    payload,
  };
};

export const addGlobalJournalSearchResults = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_JOURNAL_SEARCH_RESULTS,
    payload,
  };
};

// Curriculum search
export const setGlobalCurriculumSearchResults = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_CURRICULUM_SEARCH_RESULTS,
    payload,
  };
};

export const addGlobalCurriculumSearchResults = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_CURRICULUM_SEARCH_RESULTS,
    payload,
  };
};

// Categories search
export const setGlobalCategoriesSearchResults = (payload) => {
  return {
    type: actionTypes.SET_GLOBAL_CATEGORIES_SEARCH_RESULTS,
    payload,
  };
};

export const addGlobalCategoriesSearchResults = (payload) => {
  return {
    type: actionTypes.ADD_GLOBAL_CATEGORIES_SEARCH_RESULTS,
    payload,
  };
};
